module.exports = __webpack_public_path__ + "c222aac22b899a9084395ddb63208210.jpg";